export default __webpack_public_path__ + "static/favicon-f0c2df2302de267977474b2bcb5b1029.ico";